import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import DistributionNavigation from '../DistributionNavigation'
import DistributeEmptyState from '../../../UniformComponents/DistributeEmptyState'
import Button from '../../../UniformComponents/Button'
import CampaignLinksModal from '../CampaignLinks/CampaignLinksModal'
import DataTable from '../../DataTable'
import Panel from '../../../UniformComponents/Panel'
import DeleteModal from '../Modal/DeleteModal'

import '../distribute.scss'

@observer
class WebsiteEmbed extends Component {
    constructor(props) {
        super(props)

        const { distributeStore } = props

        if (distributeStore.isRapidSurvey()) {
            distributeStore.goToCampaignLinks()
        }

        distributeStore.campaignType = 'embed'
        distributeStore.getCampaigns('embed')
    }

    getColumns = () => {
        const { distributeStore, store } = this.props
        const { survey } = store

        return [
            {
                key: 'campaigntitle',
                name: 'Title',
                dataTransform: (value, row) => (
                    [
                        <span className="campaign-links-row-title">{value}</span>,
                        <pre className="campaign-links-link-input" key={`fc_${value}`}>{survey.getEmbedSrc(row.uuid, row.langCode, store.useLatestUI)}</pre>,
                    ]
                ),
            },
            {
                key: 'campaignId',
                name: '',
                dataTransform: (_, row) => (
                    <div className="campaign-links-table-actions pad-top">
                        <i className="fal fa-copy" onClick={() => store.copyText(survey.getEmbedSrc(row.uuid, row.langCode, store.useLatestUI), i18n.t('s_new_campaign_label_campaign_link'))} />
                        <i className="fal fa-edit" onClick={(e) => distributeStore.editCampaign(e, row)} />
                        <i className="fal fa-circle-xmark" onClick={() => distributeStore.showDeleteModal(row.campaignId)} />
                    </div>
                ),
                cellClass: 'center w50 pointer overflow',
            },
        ]
    }

    render() {
        const { distributeStore, store } = this.props
        const { filteredList, filterText } = distributeStore
        const { survey } = store
        const { showBranchBanner } = survey

        return (
            <div className={`${showBranchBanner ? 'branching' : ''} email-landing-content ${process.env.USE_NEW_HEADER_UI ? 'survey-view-wrapper' : ''}`}>
                <DistributionNavigation store={distributeStore} survey={store.survey} />

                <div className="email-landing-right-container">
                    <Panel style={{ padding: 20, overflow: 'visible' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>{i18n.t('distributionWebsiteEmbed.title')}</h2>

                            <Button
                                cssClass="regular tertiary"
                                onClick={distributeStore.showCampaignModal}
                                icon="fal fa-globe"
                                label={i18n.t('distributionWebsiteEmbed.create')}
                            />
                        </div>
                    </Panel>

                    {!filteredList.length && !filterText.length
                        ? (
                            <DistributeEmptyState
                                title={i18n.t('distributionWebsiteEmbed.emptyStateText')}
                                subtext={i18n.t('distributionWebsiteEmbed.emptyStateSubText')}
                                ctaText={i18n.t('distributionWebsiteEmbed.create')}
                                icon="fal fa-globe"
                                ctaIcon="fal fa-globe"
                                onClick={distributeStore.showCampaignModal}
                            />
                        )
                        : (
                            <Panel style={{ padding: 0 }}>
                                <DataTable
                                    store={distributeStore}
                                    dataSet={filteredList}
                                    inMemory
                                    columns={this.getColumns()}
                                />
                            </Panel>
                        )}
                </div>

                <CampaignLinksModal distributeStore={distributeStore} />

                <DeleteModal distributeStore={distributeStore} />
            </div>
        )
    }
}

export default WebsiteEmbed
